import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend'; // To load translations from public/locales

const i18nVerbose =
  typeof window !== 'undefined' &&
  window.localStorage?.getItem('AQIBOOST_VERBOSE_I18N') === '1';

/** Attendre cette promesse avant de monter React (évite t() avant chargement HTTP des JSON). */
const i18nInitResult = i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'fr'],
    fallbackLng: 'en',
    debug: i18nVerbose,
    ns: ['translation'],
    defaultNS: 'translation',
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    lng: 'fr',
  });

export const i18nInitPromise = Promise.resolve(i18nInitResult)
  .then(() => i18n.loadNamespaces('translation'))
  .catch((err) => {
    console.error('[i18n] Échec initialisation ou chargement des traductions:', err);
  });

if (i18nVerbose) {
  i18n.on('failedLoading', (lng, ns, msg) => {
    console.warn(`[i18n] Échec chargement: ${lng}/${ns} - ${msg}`);
  });
  i18n.on('loaded', (loaded) => {
    console.log('[i18n] Ressources chargées:', loaded);
  });
  i18n.on('languageChanged', (lng) => {
    console.log('[i18n] Langue:', lng);
  });
}

export default i18n;
